import React from 'react';
import noImage from '../../../../assets/images/no-image.png';
import { hideImage, showBigImage } from '../../../../Components/helper';

function careImage({ eleItem, handleUploadImage, handleDeleteImage, i, imgPath }) {
  const setImage = (item) => {
    let imagePath = '';
    if (item?.image && item.image.includes('data:image/png;base64')) {
      imagePath = item.image;
    } else if (item?.image) {
      imagePath = `${imgPath}/${item.image}`;
    } else {
      imagePath = noImage;
    }
    return imagePath;
  };
  return (
    <div className="d-flex align-items-center justify-content-center">
      <div className="image-detail d-inline-block">
        <figure className="m-0" onMouseOver={(e) => showBigImage(e)} onMouseLeave={() => hideImage()}>
          <div className="img-preview-inside-table sm">
            <img width="60" alt="product img" src={setImage(eleItem)} />
          </div>
        </figure>
      </div>
      {eleItem?.editMode && (
        <div className="d-flex flex-column">
          <button
            type="button"
            onClick={() => {
              handleUploadImage(i);
            }}
            className="btn"
          >
            <span className="icon-upload" />
          </button>
          {eleItem?.image && (
            <button
              type="button"
              onClick={() => {
                handleDeleteImage(i);
              }}
              className="btn"
            >
              <span className="icon-delete" />
            </button>
          )}
        </div>
      )}
    </div>
  );
}
export default careImage;
